import { useEffect } from 'react';
import { dismissCustomerIOMessage } from './customerio';

function CustomerIODebug({ authCtx, bearerToken }) {
  useEffect(() => {
    if (window.Gist) {
      window.testDismissMessage = () => {
        dismissCustomerIOMessage();
      };

      window.testMessageCheck = () => {
        if (window.Gist && typeof window.Gist.showMessage === 'function') {
          try {
            window.Gist.showMessage();
          } catch (error) {
            console.error('Error in manual Gist.showMessage():', error);
          }
        }
      };

      window.checkUserIdentification = () => {
        console.log('User identification status:', {
          userId: authCtx.idData.sub,
          analyticsAvailable: !!window.cioanalytics,
          gistAvailable: !!window.Gist,
          storedUser: localStorage.getItem('customerio_user'),
          currentMessages: window.Gist ? window.Gist.currentMessages : null,
        });
      };
    }
  }, [bearerToken, authCtx.idData.sub]);

  return null;
}

export default CustomerIODebug;
